import React, { useEffect, useState } from "react";
import { getSavedTaskLogs } from "../../utils/APIs";
import { useUserContext } from "../../contexts/UserContext";
import PrimaryModal from "../UI/Modal/PrimaryModal";
import caretUp from "../../assets/caret-up.svg";
import caretDown from "../../assets/caret-down.svg";
import {
    createColumnHelper,
    flexRender,
    getCoreRowModel,
    getFilteredRowModel,
    getSortedRowModel,
    useReactTable,
} from "@tanstack/react-table";
import TableShimmer from "../UI/Shimmer/TableShimmer";
import dayjs from 'dayjs';
import { useContentfulContext } from "../../contexts/ContentfulContext";

const SavedTaskLogsModal = ({ setShowLogId, showLogId }) => {
    const { userData } = useUserContext()
    const { content } = useContentfulContext();

    const [sorting, setSorting] = React.useState([]);
    const [globalFilter, setGlobalFilter] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [data, setData] = useState([])

    useEffect(() => {
        getSavedTasksData()
    }, [])

    const getSavedTasksData = async () => {
        try {
            setLoading(true);
            const result = await getSavedTaskLogs(
                userData?.token,
                userData?.selectedOrganization?.org_token,
                showLogId
            );
            setError("")
            setData(result.data);
        } catch (error) {
            console.log("error getSavedTasksData: ", error);
            setError(error?.message || content?.COMMON_MESSAGE.something_wrong_msg)
        } finally {
            setLoading(false);
        }
    };

    const columnHelper = createColumnHelper(content.USER_MANAGEMENT_TASK_LOGS_MODAL_CONTENT.integrations);

    const columns = [
        columnHelper.accessor('type', {
            header: content.USER_MANAGEMENT_TASK_LOGS_MODAL_CONTENT.logs_table_headers.type,
            footer: info => info.column.id,
            enableGlobalFilter: false
        }),
        columnHelper.accessor('description', {
            header: content.USER_MANAGEMENT_TASK_LOGS_MODAL_CONTENT.logs_table_headers.type,
            footer: info => info.column.id,
            enableGlobalFilter: false
        }),
        columnHelper.accessor('createdAt', {
            header: content.USER_MANAGEMENT_TASK_LOGS_MODAL_CONTENT.logs_table_headers.created_at,
            cell: info => dayjs(info.renderValue()).format('DD/MM/YYYY HH:mm'),
            footer: info => info.column.id,
            enableGlobalFilter: false
        }),
    ]

    const table = useReactTable({
        data,
        columns,
        state: {
            sorting,
            globalFilter
        },
        onSortingChange: setSorting,
        onGlobalFilterChange: setGlobalFilter,
        getFilteredRowModel: getFilteredRowModel(),
        getCoreRowModel: getCoreRowModel(),
        getSortedRowModel: getSortedRowModel(),
        debugTable: true,
    })

  return (
    <>
        <PrimaryModal widthClass={"max-w-5xl"} title={content.USER_MANAGEMENT_TASK_LOGS_MODAL_CONTENT.title} hideModal={() => setShowLogId(false)}>
            <div className='p-6 space-y-6 max-h-[500px] overflow-y-auto'>
            {loading && <TableShimmer colSize={4} rowSize={6}/>}
            {!loading && error && <h3 className="text-center">{error}</h3>}
            {!loading && !error && data?.length == 0 && <h3 className="text-center">{content.USER_MANAGEMENT_TASK_LOGS_MODAL_CONTENT.no_logs_found}</h3>}
            {!loading && !error && data?.length > 0 && <table className='w-full text-sm text-left text-black'>
                <thead className='text-sm text-black uppercase bg-gray-50'>
                    {table.getHeaderGroups().map(headerGroup => (
                        <tr key={headerGroup.id}>
                            {headerGroup.headers.map(header => {
                                return (
                                    <th key={header.id} colSpan={header.colSpan} className='px-6 py-3'>
                                        {header.isPlaceholder ? null : (
                                            <div
                                                {...{
                                                    className: header.column.getCanSort()
                                                        ? 'cursor-pointer select-none'
                                                        : '',
                                                    onClick: header.column.getToggleSortingHandler(),
                                                }}
                                            >
                                                {flexRender(
                                                    header.column.columnDef.header,
                                                    header.getContext()
                                                )}
                                                {{
                                                    asc: <img alt='' src={caretUp} className='w-6 h-6 inline-block align-middle' />,
                                                    desc: <img alt='' src={caretDown} className='w-6 h-6 inline-block align-middle' />,
                                                }[header.column.getIsSorted()] ?? null}
                                            </div>
                                        )}
                                    </th>
                                )
                            })}
                        </tr>
                    ))}
                </thead>
                <tbody>
                    {table.getRowModel().rows.map(row => {
                            return (
                                <tr key={row.id} className='bg-white border-b'>
                                    {row.getVisibleCells().map(cell => {
                                        return (
                                            <td key={cell.id} title="" className={`px-6 py-3 ${cell.column.id == 'organisation_name' ? 'text-primary cursor-pointer' : ''}`} onClick={() => { }}>
                                                {flexRender(
                                                    cell.column.columnDef.cell,
                                                    cell.getContext()
                                                )}
                                            </td>
                                        )
                                    })}
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>}
            </div>
        </PrimaryModal>
    </>
  )
}

export default SavedTaskLogsModal